/**
 * @param RefinementClassCreator Base widget for extending
 * @returns Refinement widget
 */
function CoreRefinementClassCreator(RefinementClassCreator: import('widgets/search/Refinement').TRefinement) {
    /**
     * @category widgets
     * @subcategory search
     * @class CoreRefinement
     * @augments RefinementClassCreator
     * @classdesc Represents Refinement component with next features:
     * 1. Support keyboard navigation for accessibility
     * 2. Support all typo of refinement
     * 3. Use "update" and "uncheck" event to handle changes used parent methods
     * 4. Using mustache template for dynamic rendering
     *
     * Refinement widget should be inside {@link RefinementMenuItem} widgets that implement refinement.
     * @property {string} data-widget - Widget name `refinement`
     * @property {string} data-widget-event-click - Event listener to call Parent's widget method
     * @property {string} data-event-click - Event listener method `handleClick` for click event on widget
     * @property {string} data-attr-id - attribute id
     * @property {string} data-attr-value - attribute value for on price refinement
     * @property {string} data-value-from - from value for price refinement
     * @property {string} data-value-to - to value for price refinement
     * @property {string} data-event-keydown - keydown handler
     * @property {string} data-widget-event-update="updateRefinementControls"
     * @property {string} data-widget-event-uncheck="uncheckRefinements"
     * @property {string} data-event-click - click handler
     * @property {string} data-checked - checked flag, used for initialization
     * @property {string} [data-prevent-action=false] - prevent any action flag
     *
     * @example <caption>Example of Refinement widget usage</caption>
     * <div
     *     class="b-refinement_link"
     *     role="menuitem"
     *     aria-checked="false"
     *     aria-disabled="false"
     *     data-widget="refinement"
     *     data-href="{{url}}"
     *     data-event-keydown.prevent="handleKeydown"
     *     data-widget-event-update="updateView"
     *     data-event-click.prevent="changeState"
     *     data-prevent-action="{{${'#'}selected}}true{{/selected}}{{^selected}}false{{/selected}}"
     *     title="{{${'#'}selected}}${Resource.msg('msg.assistive.selected.text', 'common', null)}{{/selected}} {{title}}"
     *     tabindex="0"
     *     {{${'#'}selected}}
     *         data-tau="refinements_option_selected"
     *     {{/selected}}
     * >
     *     <span data-tau="refinements_option_name">
     *         {{displayValue}} {{${'#'}hitCount}}({{hitCount}}){{/hitCount}}
     *     </span>
     * </div>
     */
    class CoreRefinement extends RefinementClassCreator {
        /**
         * @description Toggle check status
         */
        toggleCheck() {
            super.toggleCheck();

            if (this.attrId === 'sizeName') {
                this.eventBus().emit('refinement.menu.item.update.checked', this);
            }
        }
    }

    return CoreRefinement;
}

export type TCoreRefinement = ReturnType<typeof CoreRefinementClassCreator>;

export type TCoreRefinementInstance = InstanceType<TCoreRefinement>;

export default CoreRefinementClassCreator;
